import { Component, input, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IColumn } from '@app/shared/interfaces/column.interface';
import { IFiltredDashboardResponse } from '@app/shared/interfaces/dashboard.interface';
import { TableComponent } from '@app/shared/components/table-component/table.component';
import { ExcelButtonComponent } from '@app/shared/components/excel-button/excel-button.component';
import { CardComponent } from '@app/shared/components/card/card.component';

@Component({
    selector: 'app-best-seller-route',
    imports: [CommonModule, TableComponent, ExcelButtonComponent, CardComponent],
    templateUrl: './best-seller-route.component.html',
    styleUrl: './best-seller-route.component.scss'
})
export class BestSellerRouteComponent {
    routeTemplate = viewChild('routeTemplate');
    growthTemplate = viewChild('growthTemplate');
    revenueTemplate = viewChild('revenueTemplate');

    loading = input<boolean>(false);
    bestSellerRouteData = input<IFiltredDashboardResponse['bestSellerRoute']['results']>();

    cols: IColumn[] = [];

    ngOnInit() {
        this.cols = [
            { key: 'route', label: 'Route', template: this.routeTemplate(), sortable: true, sortField: 'route.depPort' },
            { key: 'reservation', label: 'Reservation', sortable: true },
            { key: 'lastYearReservation', label: 'Last Year', sortable: true },
            { key: 'growth', label: 'Performance', template: this.growthTemplate(), sortable: false },
            { key: 'topSellerAgent', label: 'Top Seller Agent', sortable: true },
            { key: 'revenue', label: 'Revenue', template: this.revenueTemplate(), sortable: true }
        ];
    }

    exportData(): any[] {
        return (
            this.bestSellerRouteData()?.map((item) => ({
                depPort: item.route.depPort ?? '',
                arrPort: item.route.arrPort ?? '',
                reservation: item.reservation ?? '',
                lastYearReservation: item.lastYearReservation ?? '',
                topSellerAgent: item.topSellerAgent ?? '',
                revenue: item.revenue ?? ''
            })) ?? []
        );
    }
}
